<!-- <button *ngIf="(formSectionError$ | async)" mat-icon-button>
    <mat-icon class="red-fg">error</mat-icon>
</button> -->
{{ translationBase + '.forms.entityForm.sections.' + section | translate }}
